import type { SchemaListFilters } from './types';

export const toListSchemasParams = (filters: SchemaListFilters) => {
  return Object.fromEntries(
    Object.entries(filters).filter(
      ([, value]) => value !== undefined && value !== '',
    ),
  );
};
